/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//react native imports
import { NativeModules } from 'react-native';

//ReactNativeErrorBoundary imports
import Constants from './analytics.constants';
import { crashlytics } from './firebaseCrashlytics';

export function log_analytics(lobName: string, screenName: string, e: Error) {
  const payload = {
    description: e.message,
    functionality: '',
    label: `${Constants.eventName}|${e.message}}|||`,
    screenName: screenName,
    code: Constants.eventName,
    category: `${lobName}`,
    action: Constants.eventName,
  };
  NativeModules?.NativeAnalytics?.trackEvent?.(
    Constants.type,
    Constants.eventName,
    payload,
  );
}

export async function log_crashlytics(e: Error, lobName: string) {
  if (crashlytics) {
    crashlytics.recordError(e, `CLIENT_SIDE_ERROR - ${lobName}`);
  }
}
